import { ApplicationRef, ComponentRef, Injectable, createComponent, Type } from '@angular/core';
import { WidgetModalComponent } from '../widgets/modal/modal.component';

@Injectable({
    providedIn: 'root'
})
export class ModalHelper {

    /**
     * Modal reference
     */
    private reference?: ComponentRef<WidgetModalComponent>;

    /**
     * Construct helper
     */
    constructor(
        private app: ApplicationRef
    ) { }

    /**
     * Open modal
     * 
     * @param component 
     * @param heading 
     * @param inputs 
     */
    open<T>(component: Type<T>, heading: string, inputs: Partial<T> = {}) {
        this.reference = createComponent(WidgetModalComponent, { environmentInjector: this.app.injector });
        this.app.attachView(this.reference.hostView);
        document.body.appendChild(this.reference.location.nativeElement);
        this.reference.instance.init(component, heading, inputs);
        this.reference.instance.closed = () => this.close();
    }

    /**
     * Close modal
     */
    close() {
        if (this.reference) {
            this.app.detachView(this.reference.hostView);
            this.reference.destroy();
            this.reference = undefined;
        }
    }
}
